// src/forms/companyProfileConfig.js

const CompanyProfileConfig = [
  {
    name: 'name',
    label: 'Company Name',
    type: 'text',
    placeholder: 'Enter company name',
    rules: { required: 'Company name is required' },
  },
  {
    name: 'tagline',
    label: 'Tagline',
    type: 'text',
    placeholder: 'Enter tagline',
    rules: {},
  },
  {
    name: 'phone_number',
    label: 'Phone Number',
    type: 'text',
    placeholder: 'Enter phone number',
    rules: { required: 'Phone number is required' },
  },
  {
    name: 'email',
    label: 'Email',
    type: 'email',
    placeholder: 'Enter email',
    rules: { required: 'Email is required' },
  },
  {
    name: 'country',
    label: 'Country',
    type: 'text',
    placeholder: 'Enter country',
    rules: { required: 'Country is required' },
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    placeholder: 'Enter city',
    rules: { required: 'City is required' },
  },
  {
    name: 'postal_address',
    label: 'Postal Address',
    type: 'text',
    placeholder: 'Enter postal address',
    rules: {},
  },
  {
    name: 'physical_address',
    label: 'Street Address',
    type: 'text',
    placeholder: 'Enter physical/street address',
    rules: {},
  },
  {
    name: 'gps_link',
    label: 'GPS Link',
    type: 'text',
    placeholder: 'Enter GPS map link',
    rules: {},
  },
];
export default CompanyProfileConfig;
  